import PropTypes from "prop-types";
import React from "react";
import TradeFilterFormDesktop from "./TradeFilterFormDesktop.jsx";
import TradeFilterFormMobile from "./TradeFilterFormMobile.jsx";

const TradeFilterForm = (props) => {

  const renderMobileTradeFilterForm = () => {
    return (
      <TradeFilterFormMobile
        loggedInUserData={props.loggedInUserData}
        isAdminPage={props.isAdminPage}
        title={props.title}
        trades={props.trades}
        tradeTypeFilters={props.tradeTypeFilters}
        allTradeTypeFilters={props.allTradeTypeFilters}
        onTradeTypeFilterChange={props.onTradeTypeFilterChange}
        isTradeTypeSelectAllChecked={props.isTradeTypeSelectAllChecked}
        isTradeTypeSelectAllIndeterminate={props.isTradeTypeSelectAllIndeterminate}
        statusFilters={props.statusFilters}
        allStatusFilters={props.allStatusFilters}
        onStatusFilterChange={props.onStatusFilterChange}
        isStatusSelectAllChecked={props.isStatusSelectAllChecked}
        isStatusSelectAllIndeterminate={props.isStatusSelectAllIndeterminate}
        searchString={props.searchString}
        searchStringErrors={props.searchStringErrors}
        tradeFoundByReferenceNumberSearch={props.tradeFoundByReferenceNumberSearch}
        tradeFoundByReferenceNumberSearchIsLoading={props.tradeFoundByReferenceNumberSearchIsLoading}
        tradeFoundByReferenceNumberSearchIsDialogOpen={props.tradeFoundByReferenceNumberSearchIsDialogOpen}
        onClickTradeFoundByReferenceNumberSearchDialogOpen={props.onClickTradeFoundByReferenceNumberSearchDialogOpen}
        onClickTradeFoundByReferenceNumberSearchDialogClose={props.onClickTradeFoundByReferenceNumberSearchDialogClose}
        onSearchChange={props.onSearchChange}
        onSearchBlur={props.onSearchBlur}
        onSearchEnterKeyPressed={props.onSearchEnterKeyPressed}
        onSearchCancel={props.onSearchCancel}
        onSearchSubmit={props.onSearchSubmit}
        mobileSortByValue={props.mobileSortByValue}
        onMobileSortByChange={props.onMobileSortByChange}
        onMobileFilterDialogClose={props.onMobileFilterDialogClose}
        isMobileFilterDialogOpen={props.isMobileFilterDialogOpen}
        onClickMobileFilterDialogOpen={props.onClickMobileFilterDialogOpen}
        onClickMobileFilterDialogApplyFiltersButton={props.onClickMobileFilterDialogApplyFiltersButton}
        isDesktopView={props.isDesktopView}
      />
    );
  };

  const renderDesktopTradeFilterForm = () => {
    return (
      <TradeFilterFormDesktop
        loggedInUserData={props.loggedInUserData}
        isAdminPage={props.isAdminPage}
        title={props.title}
        trades={props.trades}
        dateTypeFilter={props.dateTypeFilter}
        onDateTypeFilterChange={props.onDateTypeFilterChange}
        startDateFilter={props.startDateFilter}
        startDateFilterErrors={props.startDateFilterErrors}
        onStartDateFilterChange={props.onStartDateFilterChange}
        endDateFilter={props.endDateFilter}
        endDateFilterErrors={props.endDateFilterErrors}
        onEndDateFilterChange={props.onEndDateFilterChange}
        tradeTypeFilters={props.tradeTypeFilters}
        allTradeTypeFilters={props.allTradeTypeFilters}
        onTradeTypeFilterChange={props.onTradeTypeFilterChange}
        isTradeTypeSelectAllChecked={props.isTradeTypeSelectAllChecked}
        isTradeTypeSelectAllIndeterminate={props.isTradeTypeSelectAllIndeterminate}
        statusFilters={props.statusFilters}
        allStatusFilters={props.allStatusFilters}
        onStatusFilterChange={props.onStatusFilterChange}
        isStatusSelectAllChecked={props.isStatusSelectAllChecked}
        isStatusSelectAllIndeterminate={props.isStatusSelectAllIndeterminate}
        workgroupFilters={props.workgroupFilters}
        allWorkgroupFilters={props.allWorkgroupFilters}
        onWorkgroupFilterChange={props.onWorkgroupFilterChange}
        isWorkgroupSelectAllChecked={props.isWorkgroupSelectAllChecked}
        isWorkgroupSelectAllIndeterminate={props.isWorkgroupSelectAllIndeterminate}
        stations={props.stations}
        featureConfig={props.featureConfig}
        stationFilter={props.stationFilter}
        onStationFilterChange={props.onStationFilterChange}
        searchString={props.searchString}
        searchStringErrors={props.searchStringErrors}
        tradeFoundByReferenceNumberSearch={props.tradeFoundByReferenceNumberSearch}
        tradeFoundByReferenceNumberSearchIsLoading={props.tradeFoundByReferenceNumberSearchIsLoading}
        tradeFoundByReferenceNumberSearchIsDialogOpen={props.tradeFoundByReferenceNumberSearchIsDialogOpen}
        onClickTradeFoundByReferenceNumberSearchDialogOpen={props.onClickTradeFoundByReferenceNumberSearchDialogOpen}
        onClickTradeFoundByReferenceNumberSearchDialogClose={props.onClickTradeFoundByReferenceNumberSearchDialogClose}
        onSearchChange={props.onSearchChange}
        onSearchBlur={props.onSearchBlur}
        onSearchEnterKeyPressed={props.onSearchEnterKeyPressed}
        onSearchCancel={props.onSearchCancel}
        onSearchSubmit={props.onSearchSubmit}
        isDesktopView={props.isDesktopView}
      />
    );
  };

  return <div>{props.isDesktopView ? renderDesktopTradeFilterForm() : renderMobileTradeFilterForm()}</div>;
};

TradeFilterForm.propTypes = {
  loggedInUserData: PropTypes.object.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  trades: PropTypes.array.isRequired,
  dateTypeFilter: PropTypes.string.isRequired,
  onDateTypeFilterChange: PropTypes.func.isRequired,
  startDateFilter: PropTypes.object.isRequired,
  startDateFilterErrors: PropTypes.string.isRequired,
  onStartDateFilterChange: PropTypes.func.isRequired,
  endDateFilter: PropTypes.object.isRequired,
  endDateFilterErrors: PropTypes.string.isRequired,
  onEndDateFilterChange: PropTypes.func.isRequired,
  tradeTypeFilters: PropTypes.array.isRequired,
  allTradeTypeFilters: PropTypes.array.isRequired,
  onTradeTypeFilterChange: PropTypes.func.isRequired,
  isTradeTypeSelectAllChecked: PropTypes.func.isRequired,
  isTradeTypeSelectAllIndeterminate: PropTypes.func.isRequired,
  statusFilters: PropTypes.array.isRequired,
  allStatusFilters: PropTypes.array.isRequired,
  onStatusFilterChange: PropTypes.func.isRequired,
  isStatusSelectAllChecked: PropTypes.func.isRequired,
  isStatusSelectAllIndeterminate: PropTypes.func.isRequired,
  workgroupFilters: PropTypes.array.isRequired,
  allWorkgroupFilters: PropTypes.array.isRequired,
  onWorkgroupFilterChange: PropTypes.func.isRequired,
  isWorkgroupSelectAllChecked: PropTypes.func.isRequired,
  isWorkgroupSelectAllIndeterminate: PropTypes.func.isRequired,
  stationFilter: PropTypes.string.isRequired,
  searchString: PropTypes.string.isRequired,
  searchStringErrors: PropTypes.string.isRequired,
  tradeFoundByReferenceNumberSearch: PropTypes.object,
  tradeFoundByReferenceNumberSearchIsLoading: PropTypes.bool.isRequired,
  tradeFoundByReferenceNumberSearchIsDialogOpen: PropTypes.bool.isRequired,
  onClickTradeFoundByReferenceNumberSearchDialogOpen: PropTypes.func.isRequired,
  onClickTradeFoundByReferenceNumberSearchDialogClose: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onSearchBlur: PropTypes.func.isRequired,
  onSearchEnterKeyPressed: PropTypes.func.isRequired,
  onSearchCancel: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,

  // Trade Admin only props
  stations: PropTypes.array,
  onStationFilterChange: PropTypes.func,

  // Employee Trades only props
  mobileSortByValue: PropTypes.string,
  onMobileSortByChange: PropTypes.func,
  onMobileFilterDialogClose: PropTypes.func,
  isMobileFilterDialogOpen: PropTypes.bool,
  onClickMobileFilterDialogOpen: PropTypes.func,
  onClickMobileFilterDialogApplyFiltersButton: PropTypes.func,
  isDesktopView: PropTypes.bool.isRequired,
};

export default TradeFilterForm;
